module.exports = __webpack_public_path__ + "img/login_8on.cad6cae9.png";